module.exports = __webpack_public_path__ + "static/media/map.e87fa312.webp";